import React from "react";
import { ClientFormScreen } from "../../../components/client-forms/ClientFormScreen";

export function ClientFormRoute() {
  return <ClientFormScreen />;
}
